/* src/app/shared/components/flow-drop-down/flow-drop-down-item/flow-drop-down-item.component.scss */
.drop-down-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  gap: 8px;
  cursor: pointer;
  width: calc(100% - 16px);
  border-radius: 8px;
  margin-left: 8px;
  margin-right: 8px;
  padding: 8px 12px;
  transition: background-color 0.1s ease-in-out;
}
.drop-down-item img {
  height: 18px;
  width: 18px;
  filter: brightness(0) saturate(100%) invert(45%) sepia(10%) saturate(279%) hue-rotate(202deg) brightness(95%) contrast(85%);
}
.drop-down-item .small-avatar {
  height: 24px;
  width: 24px;
  border-radius: 999px;
  border: 1px solid #e4e4e7;
  background-color: #f4f4f5;
  filter: none;
}
.drop-down-item .avatar {
  width: 36px !important;
  height: 36px !important;
  border-radius: 8px;
  border: 1px solid #e4e4e7;
  filter: none;
}
.drop-down-item .title-with-subtitle {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.drop-down-item .title-with-subtitle .subtitle {
  color: #71717a;
}
.drop-down-item .destructive {
  color: #b91c1c;
}
.drop-down-item img.destructive,
.drop-down-item img + .destructive {
  filter: brightness(0) saturate(100%) invert(27%) sepia(57%) saturate(2736%) hue-rotate(341deg) brightness(74%) contrast(108%);
}
.drop-down-item:hover {
  background-color: #f4f4f5;
}
.drop-down-item:focus {
  background-color: #e0e9f9;
}
.drop-down-item.selected,
.drop-down-item.selected:hover {
  background-color: #e0e9f9;
}
.disabled {
  cursor: default;
  background-color: #ffffff;
}
.disabled p {
  color: #a1a1aa;
}
.disabled img {
  filter: brightness(0) invert(1);
}
.disabled .avatar .small-avatar {
  filter: none;
  opacity: 0.5;
}
.drop-down-item.disabled,
.drop-down-item.disabled:hover {
  cursor: not-allowed;
  background-color: #ffffff;
}
/*# sourceMappingURL=flow-drop-down-item.component.css.map */
